import { render, staticRenderFns } from "./FakeCircularLoader.vue?vue&type=template&id=ee2bb0fa&lang=pug"
import script from "./FakeCircularLoader.vue?vue&type=script&lang=js"
export * from "./FakeCircularLoader.vue?vue&type=script&lang=js"
import style0 from "./FakeCircularLoader.vue?vue&type=style&index=0&id=ee2bb0fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports